module.exports = __webpack_public_path__ + "img/memo.69e0cb73.jpeg";